angular.module('app').component('adminField', {
    templateUrl: 'events/components/field.html',
    transclude: true,
    bindings: {
        hint: '@?',
        label: '@?',
        required: '<?'
    }
});
